/* @flow */
import idx from 'idx';
import React from 'react';
import { pick } from 'lodash';
import { graphql } from 'react-apollo';

import GET_CONTENT_SOURCE_PROVIDER_QUERY from '../queries/ContentSourceProviderQuery.gql';
import UPDATE_CONTENT_SOURCES_PROVIDER_MUTATION from '../queries/UpdateContentSourcesProviderMutation.gql';

import type { ContentSourceProviderContainer as ContentSourceProviderContainerQuery } from '../queries/__generated__/ContentSourceProviderContainer';

type Props = {
  uuid: string,
  mutate: Function,
  children: Function,
  data: ReactApolloData<ContentSourceProviderContainerQuery>,
};

const UPDATABLE = [
  'title',
  'providerIconUrl',
  'organizationUUID',
  'contentWebhookUrl',
  'enabledByProvider',
  'bigPreviewWebhookUrl',
  'productLongDescription',
  'productShortDescription',
];

const DEFAULTS = {
  title: '',
  providerIconUrl: '',
  contentWebhookUrl: '',
  enabledByProvider: false,
  bigPreviewWebhookUrl: '',
  productLongDescription: '',
  productShortDescription: '',
};

class ContentSourceProviderContainer extends React.Component<Props, {}> {
  getContentSourceProvider = () => {
    return idx(this.props, _ => _.data.contentSourceProvider);
  };

  update = (attributes: *) => {
    const mutationInput = pick(
      {
        ...DEFAULTS,
        ...(this.getContentSourceProvider() || {}),
        ...attributes,
        organizationUUID: this.props.uuid,
      },
      UPDATABLE
    );

    return this.props
      .mutate({
        variables: {
          input: mutationInput,
        },
      })
      .then(result => {
        const error = idx(result, _ => _.data.updateContentSourceProvider.error.message);

        if (error) {
          throw new Error(error);
        } else {
          return result;
        }
      });
  };

  render() {
    return this.props.children({
      contentSourceProvider: this.getContentSourceProvider(),
      loading: this.props.data.loading,
      update: this.update,
    });
  }
}

const withTheContentSourceProviderMutation = graphql(UPDATE_CONTENT_SOURCES_PROVIDER_MUTATION);

const withTheContentSourceProvider = graphql(GET_CONTENT_SOURCE_PROVIDER_QUERY, {
  options: ({ uuid }) => ({
    fetchPolicy: 'network-only',
    variables: { uuid },
  }),
});

export { ContentSourceProviderContainer };
export default withTheContentSourceProviderMutation(
  withTheContentSourceProvider(ContentSourceProviderContainer)
);
